/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * chain | interactive.
 */
export const UpdateUserSessionIssuerFormAuthnChallengeMode = {
  Chain: "chain",
  Interactive: "interactive",
} as const;
/**
 * chain | interactive.
 */
export type UpdateUserSessionIssuerFormAuthnChallengeMode = ClosedEnum<
  typeof UpdateUserSessionIssuerFormAuthnChallengeMode
>;

/**
 * Which CIMD (OAuth Client ID Metadata Document) clients this issuer admits. 'presets' admits Speakeasy's curated catalog plus this issuer's custom URLs; 'open' admits any spec-valid document; 'disabled' admits none and stops advertising CIMD support. Omit to leave unchanged.
 */
export const UpdateUserSessionIssuerFormClientIdMetadataAdmissionMode = {
  Disabled: "disabled",
  Presets: "presets",
  Open: "open",
} as const;
/**
 * Which CIMD (OAuth Client ID Metadata Document) clients this issuer admits. 'presets' admits Speakeasy's curated catalog plus this issuer's custom URLs; 'open' admits any spec-valid document; 'disabled' admits none and stops advertising CIMD support. Omit to leave unchanged.
 */
export type UpdateUserSessionIssuerFormClientIdMetadataAdmissionMode =
  ClosedEnum<typeof UpdateUserSessionIssuerFormClientIdMetadataAdmissionMode>;

/**
 * Form for updating a user_session_issuer. All non-id fields are optional patches.
 */
export type UpdateUserSessionIssuerForm = {
  /**
   * chain | interactive.
   */
  authnChallengeMode?:
    | UpdateUserSessionIssuerFormAuthnChallengeMode
    | undefined;
  /**
   * Which CIMD (OAuth Client ID Metadata Document) clients this issuer admits. 'presets' admits Speakeasy's curated catalog plus this issuer's custom URLs; 'open' admits any spec-valid document; 'disabled' admits none and stops advertising CIMD support. Omit to leave unchanged.
   */
  clientIdMetadataAdmissionMode?:
    | UpdateUserSessionIssuerFormClientIdMetadataAdmissionMode
    | undefined;
  /**
   * The user_session_issuer id.
   */
  id: string;
  /**
   * Maximum issued user session lifetime, in hours.
   */
  sessionDurationHours?: number | undefined;
  /**
   * Rename the slug.
   */
  slug?: string | undefined;
};

/** @internal */
export const UpdateUserSessionIssuerFormAuthnChallengeMode$outboundSchema:
  z.ZodMiniEnum<typeof UpdateUserSessionIssuerFormAuthnChallengeMode> = z.enum(
    UpdateUserSessionIssuerFormAuthnChallengeMode,
  );

/** @internal */
export const UpdateUserSessionIssuerFormClientIdMetadataAdmissionMode$outboundSchema:
  z.ZodMiniEnum<
    typeof UpdateUserSessionIssuerFormClientIdMetadataAdmissionMode
  > = z.enum(UpdateUserSessionIssuerFormClientIdMetadataAdmissionMode);

/** @internal */
export type UpdateUserSessionIssuerForm$Outbound = {
  authn_challenge_mode?: string | undefined;
  client_id_metadata_admission_mode?: string | undefined;
  id: string;
  session_duration_hours?: number | undefined;
  slug?: string | undefined;
};

/** @internal */
export const UpdateUserSessionIssuerForm$outboundSchema: z.ZodMiniType<
  UpdateUserSessionIssuerForm$Outbound,
  UpdateUserSessionIssuerForm
> = z.pipe(
  z.object({
    authnChallengeMode: z.optional(
      UpdateUserSessionIssuerFormAuthnChallengeMode$outboundSchema,
    ),
    clientIdMetadataAdmissionMode: z.optional(
      UpdateUserSessionIssuerFormClientIdMetadataAdmissionMode$outboundSchema,
    ),
    id: z.string(),
    sessionDurationHours: z.optional(z.int()),
    slug: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      authnChallengeMode: "authn_challenge_mode",
      clientIdMetadataAdmissionMode: "client_id_metadata_admission_mode",
      sessionDurationHours: "session_duration_hours",
    });
  }),
);

export function updateUserSessionIssuerFormToJSON(
  updateUserSessionIssuerForm: UpdateUserSessionIssuerForm,
): string {
  return JSON.stringify(
    UpdateUserSessionIssuerForm$outboundSchema.parse(
      updateUserSessionIssuerForm,
    ),
  );
}
